
import _ from "lodash";
import Vue from "vue";

import { Order } from "@/model/entity/order";
import { TmpOrder } from "@/model/entity/tmp_order";
import { Menu } from "@/model/menu";

import ShopAPI from "../../common/api/api_shop";
import notificationMixin from "../../mixin/notification";
import { OrderCode } from "../../model/entity/orderSetting";
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import store from "../../store/shop";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

export default Vue.component("Cart", {
  components: {
    QButton: () => import("../../components/elements/QButton.vue"),
    SHCartCardSkeleton: () =>
      import("../../components/components/SHCartCardSkeleton.vue"),
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
    QRemainMenuOption: () =>
      import("../../components/elements/QRemainMenuOption.vue"),
    QCartListTotal: () =>
      import("../../components/elements/QCartListTotal.vue"),
  },
  filters: {
    priceFilter(price: number): string {
      if (Number.isNaN(price)) return "0";
      const formatter = new Intl.NumberFormat("ja-JP");

      return formatter.format(price);
    },
    taxPrice(prices): number {
      if (prices.tanka.exclude !== null) {
        return prices.tanka.exclude;
      }
      return prices.tanka.include;
    },
    taxTotal(prices): number {
      if (prices.total.exclude !== null) {
        return prices.total.exclude;
      }
      return prices.total.include;
    },
    numberFormat(number) {
      if (typeof number !== "number") {
        return number;
      }
      return number.toLocaleString();
    },
  },
  mixins: [notificationMixin],
  data() {
    return {
      orders: [],
      tableSessionId: this.$route.params.table_session_id,
      isNaizei: "",
      isQuick: "",
      isDeliver: "0",
      listTotal: [],
      modal: {
        data: {
          order: {} as Order,
          menu_options: undefined,
        },
        errors: {
          order: {},
        },
      },

      errors: "",
      mode: "",
      isLoading: false,

      staffId: store.state.staff.id,
      langKey: store.state.langKey,
      matchedOrders: [] as Order[],
      categoryOptions: [] as Array<{
        start_order_id: string;
        max_limit_length: number;
        formatted_name: string;
        is_auto_start: boolean;
      }>,
    };
  },
  computed: {
    prefix() {
      return this.$route.params.prefix;
    },
    shoppix() {
      return this.$route.params.shoppix;
    },
    totalQuantity(): number {
      let target = this.listTotal.find(
        (listTotal) => listTotal.tax_rate == null
      );

      return target.quantity;
    },
    totalPrice(): number {
      let total = 0;
      for (const order of this.orders) {
        if (order.prices.total.exclude !== null) {
          total += order.prices.total.exclude;
        } else {
          total += order.prices.total.include;
        }
      }

      return total;
    },
    taxType(): string {
      if (this.isNaizei === true) {
        return " (" + translate("hall-0096", "税込") + ")";
      }
      if (this.isNaizei === false) {
        return " (" + translate("hall-0097", "税抜") + ")";
      }

      return "";
    },
    onLoadDisable() {
      if (this.isLoading) {
        return "disabled";
      } else {
        return "";
      }
    },
    isModalDone(): boolean {
      return this.mode === "done";
    },
    isModalOption(): boolean {
      return this.mode === "option";
    },
    isModalReceive(): boolean {
      return this.mode === "receive";
    },
    isModalCategoryOption(): boolean {
      return this.mode === "category_option";
    },
    allValueCheckbox() {
        return this.matchedOrders.every(menu => menu.is_checked);
    },
    isAllAutoStart() {
        return this.categoryOptions.length > 0 && this.categoryOptions.every(option => option.is_auto_start);
    },
  },
  mounted() {
    api.set_token(store.state.token);
    this.fetchOrders();
  },
  methods: {
    handleClickIncrease() {
      if (this.isLoading) {
        return;
      }

      this.updateQuantity(+1);
    },
    handleClickDecrease() {
      if (this.isLoading) {
        return;
      }

      this.updateQuantity(-1);
    },
    handleClickModifyOrder(item) {
      if (this.isLoading) {
        return;
      }

      this.mode = "option";
      this.modal.data.menu_options = item.menu.menu_options;
      this.modal.data.order = _.cloneDeep(item);
    },
    handleClickOrder() {
      if (this.isLoading) {
        return;
      }
      if (store.state.shopSetting.is_select_receive) {
        this.mode = "receive";
      } else {
        this.isLoading = true;
        this.order();
      }
    },
    handleClickOrderReceive() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.order();
    },
    handleClickSubmitModify() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.submitModify();
    },
    handleClickCloseModal() {
      if (this.isLoading) {
        return;
      }

      this.closeModal();
    },
    handleClickSubmitDelete() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.submitDelete();
    },
    handleClickStart: function () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.startCategoryOption();
    },

    updateQuantity(offset) {
      const quantity = Math.max(1, this.modal.data.order.quantity + offset);
      this.modal.data.order.quantity = quantity;
    },
    optionValueRadio(option_menu) {
      const result = _.find(
        this.modal.data.order.tmp_options,
        function (row: TmpOrder) {
          if (!row.menus_menu_option) {
            return false;
          }
          return option_menu.id === row.menus_menu_option.id;
        }
      );
      return result ? true : false;
    },
    optionValueCheckbox(option_menu) {
      const result = _.findIndex(
        this.modal.data.order.tmp_options,
        function (row: TmpOrder) {
          return option_menu.id === row.menus_menu_option_id;
        }
      );
      return result !== -1;
    },
    optionChangeRadio(event, option) {
      _.remove(this.modal.data.order.tmp_options, function (row: TmpOrder) {
        if (!row.menus_menu_option) {
          return false;
        }
        return option.id === row.menus_menu_option.menu_option_id;
      });
      this.modal.data.order.tmp_options.push({
        menus_menu_option_id: _.clone(event.target.value),
        menus_menu_option: {
          menu_option_id: option.id,
        },
        quantity: this.modal.data.order.quantity,
      });
    },
    optionChangeCheckbox(event, option) {
      if (!event.target.checked) {
        const result = _.findIndex(
          this.modal.data.order.tmp_options,
          function (row: TmpOrder) {
            return event.target.value === row.menus_menu_option_id;
          }
        );
        if (result !== -1) {
          this.modal.data.order.tmp_options.splice(result, 1);
        }
      } else {
        this.modal.data.order.tmp_options.push({
          menus_menu_option_id: _.clone(event.target.value),
          menus_menu_option: {
            menu_option_id: option.id,
          },
          quantity: this.modal.data.order.quantity,
        });
      }
    },
    allChangeCheckbox(event) {
        this.matchedOrders.forEach(menu => {
            menu.is_checked = event.target.checked;
        });
    },
    closeModal() {
      this.mode = "";
      this.isLoading = false;
      this.isDeliver = "0";
      this.modal.data.order = {};
    },
    redirectToCheck() {
      this.$router.push(
        `/${this.prefix}/${this.shoppix}/table-session/check-quick/${this.tableSessionId}`
      );
    },
    redirectToHome() {
      this.$router.push(`/${this.prefix}/${this.shoppix}/home`);
    },

    order() {
      if (this.isQuick === true) {
        this.redirectToCheck();
        return;
      }

      let message = "";
      api
        .order_order({
          code: OrderCode.CODE_BY_HALLSTAFF,
          id: this.tableSessionId,
          staff_id: this.staffId,
          is_deliver: this.isDeliver,
        })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          if (response.data.orders.length > 0) {
            this.getCategoryOptionOrders(response.data.orders, response.data.table_session);
          }
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitModify() {
      let message = "";
      api
        .order_edit_tmp({ order: this.modal.data.order })
        .then((response) => {
          message = response.data.message;
          this.showSuccessNotification(message);
          this.closeModal();
          this.fetchOrders();
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.modal.errors.order = message;
          this.isLoading = false;
        });
    },
    submitDelete() {
      let message = "";
      api
        .order_delete_tmp({ order: this.modal.data.order })
        .then((response) => {
          message = response.data.message;
          this.showSuccessNotification(message);
          this.closeModal();
          this.fetchOrders();
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.modal.errors.order = message;
          this.isLoading = false;
        });
    },
    /**
     * 注文データとテーブルセッション情報をもとに、
     * 飲み放題メニュー（category_option）関連の注文を抽出し、
     * すでに注文済みオーダーの飲放題化が可能なメニューのポップアップを表示する
     *
     * @param {Array<Object>} orders - 今回の注文一覧。各要素は注文オブジェクトを想定。
     * @param {Object} table_session - テーブルセッション情報を保持するオブジェクト。
     * @param {Array<Object>} table_session.no_paid_orders - 未精算の注文一覧。
     *
     * @returns {void} この関数は値を返さず、副作用として状態を更新する。
     *
     * @example
     * getCategoryOptionOrders(response.data.orders, currentTableSession);
     */
    getCategoryOptionOrders(orders, table_session) {
        const allNopaidOrders = table_session.no_paid_orders;
        const orderedOrders = orders;

        const allYouCanDrinkOrders =
          this.extractOrdersWithAllYouCanDrinkMenu(
            allNopaidOrders,
            orderedOrders
          );

        // 飲み放題メニュー（category_optionsを持つ）を抽出
        const categoryOptionOrders = orderedOrders.filter(order =>
          order.menu.category_options && order.menu.category_options.length > 0
        );

        if (categoryOptionOrders.length === 0) {
          // 飲み放題メニューがない場合は通常の完了ポップアップ
          this.mode = "done";
          return;
        }

        // categoryOptionsを設定
        this.categoryOptions = [];
        categoryOptionOrders.forEach(order => {
          // limit_start_automatic: true/1 = 自動開始、false/0 = 手動開始
          const isAutoStart = order.menu.limit_start_automatic === true || order.menu.limit_start_automatic === 1;
          this.categoryOptions.push({
            start_order_id: order.id,
            max_limit_length: order.menu.limit_length || 0,
            formatted_name: order.formatted_name,
            is_auto_start: isAutoStart,
          });
        });

        // 既存オーダーがある場合、または手動開始の飲み放題がある場合はポップアップを表示
        const hasManualStartOption = this.categoryOptions.some(option => !option.is_auto_start);

        if (allYouCanDrinkOrders.length > 0 || hasManualStartOption) {
          this.mode = "category_option";
          this.matchedOrders = allYouCanDrinkOrders.map(order => ({
            ...order,
            is_checked: true,
            option_price: 0,
          }));
        } else {
          // 全て自動開始で既存オーダーがない場合は通常の完了ポップアップ
          this.mode = "done";
        }
    },
    startCategoryOption() {
      let message = "";
      const matchedOrdersData = this.matchedOrders.map(order => ({
        is_checked: order.is_checked,
        order_id: order.id,
        option_price: order.option_price
      }));
      api
        .start_category_option({
            matched_orders: matchedOrdersData,
            category_options: this.categoryOptions,
        })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          this.mode = "done";
          this.isLoading = false;
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
          this.isLoading = false;
        });
    },

    fetchOrders() {
      this.isLoading = true;
      let message = "";
      api
        .hallCart({ lang: this.langKey, table_session_id: this.tableSessionId })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0048", "データの取得に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          this.isLoading = false;
          if (
            response.data.data.isQuick === true &&
            response.data.data.orders.length === 0
          ) {
            this.redirectToHome();
            return;
          }
          this.orders = response.data.data.orders;
          this.isNaizei = response.data.data.isNaizei;
          this.isQuick = response.data.data.isQuick;
          this.listTotal = response.data.data.listTotal;
        })
        .catch((err) => {
          this.isLoading = false;
          message =
            err.response.data.message ||
            translate("hall-0048", "データの取得に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
        });
    },
    orderItemStyle(order) {
      if (order.quantity === 0) {
        return { opacity: 0.5 };
      } else {
        return {};
      }
    },
    extractOrdersWithAllYouCanDrinkMenu(
      checkOrders: Order[],
      orderedOrders: Order[]
    ): Order[] {
      // フラットな menus 配列を取得して、id で重複排除
      const uniqueMenus: Menu[] = Array.from(
        new Map(
          orderedOrders
            .flatMap((order) =>
              order.menu.category_options.flatMap((option) =>
                option.categories.flatMap((category) => category.menus)
              )
            )
            .map((menu) => [menu.id, menu]) // Mapで重複排除
        ).values()
      );
      if (uniqueMenus.length === 0) {
        return [];
      }
      // メニューIDの集合を作って高速に比較できるように
      const uniqueMenuIds = new Set(uniqueMenus.map((menu) => menu.id));
      const filteredOrders = checkOrders.filter(
        (order) =>
          !order.using_all_you_can_drink && uniqueMenuIds.has(order.menu_id)
      );

      return filteredOrders;
    },
    findOrderMatchingDrinkMenu(
      checkOrders: Order[],
      orderedOrders: Order[]
    ): Order[] {
      const drinkMenuIds = new Set(checkOrders.map((order) => order.menu_id));
      const matchedCategoryOptionOrders = orderedOrders.filter((order) => {
        const flattenedMenus = order.menu.category_options.flatMap((option) =>
          option.categories.flatMap((category) => category.menus)
        );
        return flattenedMenus.some((menu) => drinkMenuIds.has(menu.id));
      });

      return matchedCategoryOptionOrders;
    },
    numberFormat(number) {
      if (typeof number !== "number" || isNaN(number)) {
        return 0;
      }
      return number.toLocaleString();
    },
  },
});
